import axios from 'axios';


const $host = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Создаём экземпляр для авторизованных запросов
const $authHost = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Интерцептор для добавления токена авторизации
const authInterceptor = (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.authorization = `Bearer ${localStorage.getItem('token')}`;
  } else {
    console.warn('Токен авторизации не найден в localStorage');
  }
  return config;
};



const normalizeUrlInterceptor = (config) => {
  if (config.url) {
    config.url = config.url.replace(/^\/+/, ''); // Удаляем начальные слеши
    config.baseURL = config.baseURL?.replace(/\/+$/, ''); // Удаляем конечные слеши
  }
  return config;
};

// Применяем интерцепторы
$host.interceptors.request.use(normalizeUrlInterceptor);
$authHost.interceptors.request.use(normalizeUrlInterceptor);
$authHost.interceptors.request.use(authInterceptor);
$authHost.interceptors.response.use((response) => response);

// Экспортируем экземпляры
export {
  $host,
  $authHost
};
